import { render, staticRenderFns } from "./MyPayslips.vue?vue&type=template&id=17c2fc10&scoped=true"
import script from "./MyPayslips.vue?vue&type=script&lang=js"
export * from "./MyPayslips.vue?vue&type=script&lang=js"
import style0 from "./MyPayslips.vue?vue&type=style&index=0&id=17c2fc10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c2fc10",
  null
  
)

export default component.exports